<template>
  <div class="mb-6">
    <div class="m-4">
      <div class="flex items-baseline justify-between">
        <h4
          class="uppercase"
          v-text="'Unread notifications'"
        />
        <a
          href="#"
          @click.prevent="markAllNotificationsRead"
          v-text="'Mark all read'"
        />
      </div>
      <ul class="list-reset my-4">
        <li
          :is="notification.attributes.type"
          v-for="notification in notifications"
          :key="notification.id"
          :notification="notification"
        />
        <li
          v-if="!notifications.length"
          class="shadow p-3 mb-4"
        >
          <p
            class="my-0 text-sm"
            v-text="'There have been no documents, blogs, discussions, sms, or emails shared with you recently.'"
          />
        </li>
      </ul>
      <div
        v-if="notifications.length"
        class="flex justify-between"
      >
        <button
          type="button"
          class="btn btn--sm"
          :disabled="!prevLink"
          :aria-disabled="!prevLink"
          @click="paginate('prev')"
          v-text="'prev'"
        />
        <button
          type="button"
          class="btn btn--sm"
          :disabled="!nextLink"
          :aria-disabled="!nextLink"
          @click="paginate"
          v-text="'next'"
        />
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
import NotificationFeedMixin from './NotificationFeedMixin'

export default {
  name: 'UnreadNotifications',
  mixins: [NotificationFeedMixin],
  props: {
    notifications: {
      type: Array,
      required: true,
    },
  },
  computed: {
    prevLink() {
      return this.$store.state.notification.unread._links.prev
    },
    nextLink() {
      return this.$store.state.notification.unread._links.next
    },
  },
  methods: {
    markAllNotificationsRead() {
      this.$api.active().post('notifications/read')
        .then(() => {
          this.$store.dispatch('notificationGetNotifications')
          this.$store.dispatch('notificationGetNotifications', { type: 'read' })
        })
    },
    paginate(direction = 'next') {
      this.loaded = false

      this.$store.dispatch('notificationGetNotifications', {
        url: direction === 'next' ? this.nextLink : this.prevLink,
      })
        .then(() => {
          this.loaded = true

          window.scrollTo(top)
        })
    },
  },
}
</script>
